import { richHtmlSx } from '../rich-html-editor';

/**
 * `richHtmlSx` tuned for promo banner cards, where admin-authored title and
 * description HTML renders on a colored gradient inside a fixed-height row.
 *
 * Two things have to change versus the default rich-text styling:
 * - Block margins collapse to 0. The banner controls its own spacing via Stack;
 *   `richHtmlSx`'s `p { margin: 0 0 0.6em }` and heading margins would push the
 *   CTA out of alignment and grow the card.
 * - Links inherit their color. `richHtmlSx` paints them `primary.main`, which is
 *   unreadable against the coral gradient; inheriting keeps them legible on both
 *   the gradient (white text) and the white review pill (dark text), with the
 *   underline left in place so they still read as links.
 */
export const promoBannerRichTextSx = {
  ...richHtmlSx,
  '& p, & h1, & h2, & h3, & h4, & h5, & h6, & ul, & ol, & blockquote': {
    margin: 0,
  },
  // Headings inside a banner are emphasis, not document structure — keep them
  // at the surrounding font size so a stray H1 can't blow up the card.
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    fontSize: 'inherit',
    fontWeight: 700,
    lineHeight: 'inherit',
    margin: 0,
  },
  '& a': {
    color: 'inherit',
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
    '&:hover': { textDecoration: 'none' },
  },
  // Preserve authored line breaks the way the old plain-text rendering did.
  '& br': { lineHeight: 'inherit' },
} as const;
